module.exports = __webpack_public_path__ + "img/asanmobile3.61453d92.jpeg";